// Import the necessary components
import VerofreshRecord from './VerofreshRecord'

class CustomerApikeyRecord extends VerofreshRecord {
}

export default CustomerApikeyRecord
